export default "__VITE_ASSET__pELkrH6t__"